import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import axios from 'axios';

const CTryEditor = () => {
  const [code, setCode] = useState(`#include <stdio.h>\n\nint main() {\n    printf("Hello, World!");\n    return 0;\n}`);
  const [output, setOutput] = useState('');
  const [loading, setLoading] = useState(false);

  const runCode = async () => {
    setLoading(true);
    try {
      const response = await axios.post('https://api.jdoodle.com/v1/execute', {
        script: code,
        language: "c",
        versionIndex: "5", // latest version of C in JDoodle
        clientId: "YOUR_CLIENT_ID",
        clientSecret: "YOUR_CLIENT_SECRET"
      });

      setOutput(response.data.output);
    } catch (error) {
      setOutput('Error executing code');
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Try C Editor</h2>
      <Editor
        height="300px"
        defaultLanguage="c"
        defaultValue={code}
        onChange={(value) => setCode(value)}
      />
      <button onClick={runCode} style={{ marginTop: '10px', padding: '8px 16px' }}>
        Run Code
      </button>

      <div style={{ marginTop: '20px' }}>
        <h4>Output:</h4>
        <pre style={{ background: '#f5f5f5', padding: '10px' }}>{loading ? "Running..." : output}</pre>
      </div>
    </div>
  );
};

export default CTryEditor;
